import { h } from 'preact'
import EmptyPage from '../empty-page/EmptyPage'
import globals from '../../utils/globals'
import TitleCell from '../articles/cells/TitleCell'
import LastActivityCell from './LastActivityCell'
import CategorySelector from '../articles/CategorySelector'
import SimpleFilterSelector from '../overview/filter-selectors/SimpleFilterSelector'
import Overview from '../overview'

type Props = {
  categories: [],
  contentTypes: []
}

const ModerationOverview = ({ categories, contentTypes } : Props) => {
  const model = [{
    header: 'Title', accessor: 'title', cell: TitleCell()
  }, {
    header: 'Category', accessor: 'category'
  }, {
    header: 'Replies', accessor: 'reply_count'
  }, {
    header: 'Last Activity', accessor: 'last_activity_at', cell: LastActivityCell(), sorting: 'lastActivityAt'
  }]

  return <Overview
    type='moderation'
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    withSorting={{
      direction: 'desc',
      order: 'lastActivityAt'
    }}
    withFilters={[
      { key: 'category', data: categories, displayName: 'category', component: CategorySelector },
      { key: 'contentType', data: contentTypes, displayName: 'content type', component: SimpleFilterSelector }
    ]}
    withSearch
    counterLabel='Topics'
    rowId='id'
    model={model}
    endpoint='/overview/topics'
    dataKey='topics'
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='There are no topics yet'
      text={'Seems like no one on your team has created a topic. \n Start now by creating a new topic.'}
      button={{ link: '/content/new/article', text: 'New article' }}
    />}
  />
}

export default ModerationOverview
